export const linkTypeTag = 'linkType:';
